import { AsyncComponent } from '@frontend/components/common';
import { Application, Feature, Functionality } from '@frontend/functionality/types';
import { CommonMessage } from '@frontend/lang';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { ApplicationBundleUsageLayout } from '../../components/application-bundle-usage-layout/application-bundle-usage-layout.component';
import { checkFeatureRoute, checkLicenseRoutes } from '../utils';
import { ShopOrders } from './orders/orders.component';

const ShopPage = lazy(() => import('./shop/shop-page.component'));

export function ApplicationsShopRoutes(functionalities: Functionality[] | null) {
    const routeLicenseCheckResult = functionalities !== null ? checkLicenseRoutes(functionalities, Application.SHOP) : null;

    if (routeLicenseCheckResult && !routeLicenseCheckResult.appEnabled) {
        return null;
    }

    return (
        <Route
            path='shop'
            element={<ApplicationBundleUsageLayout application={Application.SHOP} />}>
            {checkFeatureRoute(Feature.OUTBOUND_TRANSACTION, routeLicenseCheckResult) && (
                <Route
                    path='shop'
                    element={
                        <AsyncComponent fallback={<p role='status'>{CommonMessage.FORMS.LOADING_PLACEHOLDER}</p>}>
                            <ShopPage />
                        </AsyncComponent>
                    }
                />
            )}
            {checkFeatureRoute(Feature.ORDERS, routeLicenseCheckResult) && (
                <Route
                    path='orders'
                    element={<ShopOrders />}
                />
            )}
        </Route>
    );
}
